import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import style from 'styled-components';

import { GIButton } from 'app-components';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { configs } from '../../utils';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';
import EnrollmentActionButtons from './EnrollmentActionButtons';

const StyledHeader = style.div`
    display: flex;
    justify-content: space-between;
`;
const StyledHeaderText = style.h4`
    margin: 0;
`;

const EnrollmentPremiumHistoryHeader = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const { eId } = useParams();
    const { isEdit } = useContext(EnrollmentContext);
    const { MEMBER_ENROLLMENT_RECONCILIATION } = configs.routes;

    const onBackClick = () => {
        if (eId) {
            window.location.href = MEMBER_ENROLLMENT_RECONCILIATION.replace(':eId', eId);
        } else {
            navigate(-1);
        }
    };

    return (
        <StyledHeader className="header">
            <StyledHeaderText> {intl.formatMessage({ id: 'member.enrollment_list.premiumhistory' })}</StyledHeaderText>
            <ConditionalRendering isTrue={!isEdit}>
                <GIButton
                    id="btn-back"
                    variant="secondary"
                    onClickHandler={onBackClick}
                    label={intl.formatMessage({ id: 'button.back' })}
                />
            </ConditionalRendering>
            <EnrollmentActionButtons />
        </StyledHeader>
    );
};

export default EnrollmentPremiumHistoryHeader;
